import "clsx";
import { F as Features } from "../../../../../chunks/Features.js";
function _page($$renderer) {
  Features($$renderer);
}
export {
  _page as default
};
